module.exports = __webpack_public_path__ + "assets/img/13-l.4185d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/13-l.jpg
// module id = 2/31
// module chunks = 0